<template>
  <div>
    <b-card>
      <modals-container v-model="items" />

      <template>
        <mdb-container>
          <mdb-modal
            :show="confirmar"
            @close="confirmar = false"
            size="sm"
            class="text-center"
            style="top:40px;"
            danger
          >
            <mdb-modal-header center :close="false">
              <p class="heading">Confirmar que quieres eliminar el cod Postal {{nameLine}}</p>
            </mdb-modal-header>
            <mdb-modal-body>
              <mdb-icon icon="times" size="4x" class="animated rotateIn" />
            </mdb-modal-body>
            <mdb-modal-footer center>
              <mdb-btn outline="danger" @click="eliminar()">Si</mdb-btn>
              <mdb-btn color="danger" @click="confirmar = false">No</mdb-btn>
            </mdb-modal-footer>
          </mdb-modal>
        </mdb-container>
      </template>

      <template>
        <mdb-modal :show="modal" @close="modal = false" fullHeight info removeBackdrop>
          <mdb-modal-header center :close="false">
            <p class="heading lead">{{ modalName}}</p>
          </mdb-modal-header>
          <mdb-modal-body class="modal-body">
            <modal-create-cod-postal :onClick="closeModalCreate" v-if="modalName=='Crear'"></modal-create-cod-postal>
            <modal-edit-cod-postal
              :onClick="closeModalCreate"
              :codPostal="codPostalSelected"
              v-if="modalName=='Editar'"
            ></modal-edit-cod-postal>
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="modal = false">Cancelar</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </template>

      <b-btn variant="primary" class="p-2 mb-4" @click="openModal('Crear')">
        <i class="far fa-edit mr-1"></i>
        Nuevo Cod Postal
      </b-btn>
      <div slot="header" v-html="caption"></div>
      <b-table
        :dark="dark"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        responsive="sm"
        :items="items"
        :fields="captions"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="acciones" slot-scope="data">
          <b-row>
            <div class="seleccionar col-3">
              <b-badge variant="primary" class="p-2" @click="selectCodPostalEdit(data.item,items)">
                <i class="far fa-edit mr-1"></i>Editar
              </b-badge>
            </div>
            <div class="seleccionar col-2">
              <b-badge variant="danger" class="p-2" @click="selectCodPostalDelete(data.item)">
                <i class="far fa-trash-alt mr-1"></i>Eliminar
              </b-badge>
            </div>
          </b-row>
        </template>

        <!--<template slot="status" slot-scope="data">
          <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
        </template>-->
      </b-table>
      <nav>
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />
      </nav>
    </b-card>
  </div>
</template>

<script>
import ModalCreateCodPostal from "../notifications/ModalCreateCodPostal";
import ModalEditCodPostal from "../notifications/ModalEditCodPostal";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";
export default {
  name: "table-partners",
  inheritAttrs: false,
  components: {
    ModalCreateCodPostal,
    ModalEditCodPostal,
    mdbContainer,
    SemipolarSpinner,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      modalCreate: false,
      modal: false,
      isLoadingLine: false,
      id: "",
      nameLine: "",
      descriptionLine: "",
      modalName: "",
      confirmar: false,
      codPostalSelected: {}
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    openModal(etapa) {
      if (etapa == "Crear") {
        this.nameLine = "";
        this.descriptionLine = "";
      }
      this.modalName = etapa;
      this.modal = true;
    },
    crearLine(event) {
      event.target.classList.add("was-validated");
      var { nameLine, descriptionLine } = this;
      this.isLoadingLine = true;
      if (nameLine == "" || descriptionLine == "") {
        this.isLoadingLine = false;
      } else {
        var codPostal = {};
        if (this.modalName == "Crear") {
          codPostal = {
            nameLine,
            descriptionLine
          };
          store.dispatch("newCodPostal", codPostal).then(() => {
            this.nameLine = "";
            this.descriptionLine = "";
            this.isLoadingLine = false;
            this.modal = false;
          });
        } else {
          codPostal = {
            id: this.id,
            nameLine,
            descriptionLine
          };
          store.dispatch("editCodPostal", codPostal).then(() => {
            this.nameLine = "";
            this.descriptionLine = "";
            this.id = "";
            this.isLoadingLine = false;
            this.modal = false;
          });
        }
      }
    },
    selectCodPostalEdit(item, items) {
      this.codPostalSelected = item;
      this.openModal("Editar");
    },
    selectCodPostalDelete(item) {
      this.id = item.id;
      this.codPostalSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    closeModalCreate() {
      this.modal = false;
    },
    eliminar() {
      setTimeout(() => {
        store.dispatch("deleteCodPostalUtility", this.id);
      }, 400);
      store.dispatch("deleteCodPostal", this.id);
      this.confirmar = false;
    }
  }
};
</script>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}
</style>
